(function () {
  function initEmotoWizard() {
    const root = document.querySelector('[data-emoto-listing]');
    if (!root) return;

    /*
     * =========================================================
     * STORAGE & CONSTANTS
     * =========================================================
     */

    const STORAGE_KEY = 'emoto_sell_listing';

    const BRAND_OPTIONS = {
      e_bike: ['Murf'],
      dirt_bike: ['Sur-Ron'],
      motorcycle: ['CAKE'],
      scooter: ['NIU'],
      golf_cart: ['Rogue'],
    };

    const MODEL_OPTIONS = {
      e_bike: ['S2'],
      dirt_bike: ['Light Bee X'],
      motorcycle: ['Kalk INK'],
      scooter: ['Model A'],
      golf_cart: ['Rogue 4'],
    };

    const CATEGORY_NAMES = {
      e_bike: 'E-Bike',
      dirt_bike: 'Dirt Bike',
      motorcycle: 'Motorcycle',
      scooter: 'Scooter',
      golf_cart: 'Golf Cart',
      other: 'Other',
    };

    const API_ENDPOINT = root.dataset.apiEndpoint || 'https://emoto-marketplace-app.vercel.app/api/listings/draft';
    const API_BASE = API_ENDPOINT.replace(/\/api\/.*$/, '');
    const PACKAGES_ENDPOINT = API_BASE + '/api/packages';
    const CHECKOUT_ENDPOINT = API_BASE + '/api/checkout';
    const SHOPIFY_CUSTOMER_ID = root.dataset.customerId || '';

    let state = {
      step: 1,
      category: '',
      listing_id: null,
      seller_id: null,
      data: {},
    };

    function saveState() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        const email = state.data.user_email || state.data.seller_email;
        if (email && email.trim()) {
          localStorage.setItem('emoto_seller_email', email.trim());
        }
      } catch (error) {
        console.warn('Unable to save EMOTO listing state.', error);
      }
    }

    function loadState() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (!saved) return;
        const parsed = JSON.parse(saved);
        if (!parsed) return;
        state = {
          step: parsed.step || 1,
          category: parsed.category || '',
          listing_id: parsed.listing_id || null,
          seller_id: parsed.seller_id || null,
          data: parsed.data || {},
        };
      } catch (error) {
        console.warn('Unable to load EMOTO listing state.', error);
      }
    }

    function collectAllCurrentData() {
      const currentStep = state.step || 1;
      if (currentStep === 1) {
        const emailInput = root.querySelector('[data-field="user_email"]');
        if (emailInput && emailInput.value.trim()) {
          state.data.user_email = emailInput.value.trim();
        }
        const phoneInput = root.querySelector('[data-field="user_phone"]');
        if (phoneInput && phoneInput.value.trim()) {
          state.data.user_phone = phoneInput.value.trim();
        }
        const optin = root.querySelector('[data-check-field="marketing_optin"]');
        if (optin) {
          state.data.marketing_optin = optin.checked;
        }
      } else if (currentStep === 2) {
        if (typeof collectFields === 'function') collectFields();
      } else if (currentStep === 3) {
        if (typeof collectConditionFields === 'function') collectConditionFields();
      } else if (currentStep === 5) {
        if (typeof collectPriceFields === 'function') collectPriceFields();
      } else if (currentStep === 6) {
        if (typeof collectContactFields === 'function') collectContactFields();
      }
      saveState();
    }

    /*
     * =========================================================
     * BACKEND SYNC (AUTO-SAVE AT EVERY STEP)
     * =========================================================
     */

    async function syncDraftToBackend(targetStep, isFinal) {
      collectAllCurrentData();

      const stepNum = targetStep || state.step || 1;
      const email = state.data.user_email || state.data.seller_email;
      if (!email && !state.listing_id) {
        return;
      }

      try {
        const payload = {
          listing_id: state.listing_id || null,
          seller_id: state.seller_id || null,
          step: Number(stepNum),
          category: state.category || 'dirt_bike',
          user_email: email || '',
          user_phone: state.data.user_phone || state.data.seller_phone || '',
          seller_email: state.data.seller_email || email || '',
          seller_name: state.data.seller_name || '',
          seller_phone: state.data.seller_phone || state.data.user_phone || '',
          shopify_customer_id: SHOPIFY_CUSTOMER_ID || state.data.shopify_customer_id || null,
          marketing_optin: state.data.marketing_optin,
          data: state.data || {},
          is_final_submit: Boolean(isFinal),
        };

        console.log('[EMOTO Auto-save Syncing Step ' + stepNum + '...]', payload);

        const response = await fetch(API_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          const resData = await response.json();
          console.log('[EMOTO Auto-save Response OK]:', resData);
          if (resData.listing_id) {
            state.listing_id = resData.listing_id;
            state.seller_id = resData.seller_id;
            saveState();
          }
        } else {
          const errText = await response.text();
          console.error('[EMOTO Auto-save HTTP Error]:', response.status, errText);
        }
      } catch (err) {
        console.error('[EMOTO Auto-save Network/Mixed-Content Error]:', err);
      }
    }

    /*
     * =========================================================
     * CATEGORY VISIBILITY & DYNAMIC OPTIONS
     * =========================================================
     */

    function updateCategoryVisibility() {
      const cat = state.category || 'e_bike';

      root.querySelectorAll('[data-category-label]').forEach(function (el) {
        el.textContent = CATEGORY_NAMES[cat] || cat;
      });

      root.querySelectorAll('[data-category-show]').forEach(function (el) {
        const allowed = el.dataset.categoryShow.split(',').map(function (s) {
          return s.trim();
        });
        el.hidden = !allowed.includes(cat);
      });

      root.querySelectorAll('[data-category-hide]').forEach(function (el) {
        const hiddenFor = el.dataset.categoryHide.split(',').map(function (s) {
          return s.trim();
        });
        el.hidden = hiddenFor.includes(cat);
      });

      updateBrandAndModelOptions(cat);
    }

    function updateBrandAndModelOptions(cat) {
      const brandSelect = root.querySelector('select[data-field="brand"]');
      const modelSelect = root.querySelector('select[data-field="model"]');

      if (brandSelect && BRAND_OPTIONS[cat]) {
        const currentVal = state.data.brand || brandSelect.value;
        brandSelect.innerHTML =
          '<option value="">Select brand</option>' +
          BRAND_OPTIONS[cat]
            .map(function (b) {
              return '<option value="' + b + '">' + b + '</option>';
            })
            .join('') +
          '<option value="Other">Other</option>';
        if (currentVal) brandSelect.value = currentVal;
      }

      if (modelSelect && MODEL_OPTIONS[cat]) {
        const currentVal = state.data.model || modelSelect.value;
        modelSelect.innerHTML =
          '<option value="">Select model</option>' +
          MODEL_OPTIONS[cat]
            .map(function (m) {
              return '<option value="' + m + '">' + m + '</option>';
            })
            .join('') +
          '<option value="Other">Other</option>';
        if (currentVal) modelSelect.value = currentVal;
      }
    }

    /*
     * =========================================================
     * COLLECT CURRENT FORM
     * =========================================================
     */

    function collectFields() {
      const stepEl = root.querySelector('.emoto-step-details');
      if (stepEl && stepEl.hidden) return;

      const form = root.querySelector('.emoto-category-form');
      if (!form) return;

      form.querySelectorAll('[data-field]').forEach(function (field) {
        if (!field.closest('[hidden]')) {
          const key = field.dataset.field;
          const val = field.value;
          state.data[key] = val;
        }
      });

      if (state.data.brand === 'Other') {
        const otherBrand = form.querySelector('[data-field="brand_other"]');
        if (otherBrand && otherBrand.value.trim()) {
          state.data.other_brand = otherBrand.value.trim();
          state.data.custom_brand = otherBrand.value.trim();
        }
      }
      if (state.data.model === 'Other') {
        const otherModel = form.querySelector('[data-field="model_other"]');
        if (otherModel && otherModel.value.trim()) {
          state.data.other_model = otherModel.value.trim();
          state.data.custom_model = otherModel.value.trim();
        }
      }
      if (state.data.color === 'Other') {
        const otherColor = form.querySelector('[data-field="color_other"]');
        if (otherColor && otherColor.value.trim()) {
          state.data.other_color = otherColor.value.trim();
          state.data.custom_color = otherColor.value.trim();
        }
      }

      saveState();
    }

    /*
     * =========================================================
     * OTHER INPUT
     * =========================================================
     */

    function updateOtherInput(field) {
      const fieldName = field.dataset.field;
      const wrapper = field.closest('.emoto-field')?.querySelector('[data-other-input="' + fieldName + '"]');

      if (!wrapper) return;

      if (field.value === 'Other') {
        wrapper.hidden = false;
      } else {
        wrapper.hidden = true;
        const input = wrapper.querySelector('input');
        if (input) {
          input.value = '';
        }
      }
    }

    /*
     * =========================================================
     * RESTORE FORM
     * =========================================================
     */

    function restoreFields() {
      const form = root.querySelector('.emoto-category-form');
      if (!form) return;

      form.querySelectorAll('[data-field]').forEach(function (field) {
        const key = field.dataset.field;
        if (state.data[key] !== undefined) {
          field.value = state.data[key];
        }
      });

      form.querySelectorAll('select[data-field]').forEach(function (select) {
        const field = select.dataset.field;
        if (field === 'brand' || field === 'model' || field === 'color') {
          updateOtherInput(select);
        }
      });
    }

    function showCategoryForm() {
      updateCategoryVisibility();
      restoreFields();
    }

    /*
     * =========================================================
     * STEP
     * =========================================================
     */

    function validateCurrentStep(step) {
      if (step === 1) {
        // If resuming a verified draft from backend/localStorage with saved email
        const hasSavedEmail = Boolean(state.data && (state.data.user_email || state.data.seller_email));
        if ((state.listing_id || state.listing_code) && hasSavedEmail) {
          const emailInput = root.querySelector('[data-field="user_email"]');
          if (emailInput && !emailInput.value) {
            emailInput.value = state.data.user_email || state.data.seller_email || '';
          }
          return true;
        }

        if (!state.category) {
          const selected = root.querySelector('.emoto-category-card.selected');
          if (selected) {
            state.category = selected.dataset.category;
          } else {
            state.category = 'dirt_bike';
            const defaultCard = root.querySelector('[data-category="dirt_bike"]');
            if (defaultCard) defaultCard.classList.add('selected');
          }
        }

        const emailInput = root.querySelector('[data-field="user_email"]');
        const emailErr = root.querySelector('[data-email-error]');
        const phoneInput = root.querySelector('[data-field="user_phone"]');
        const phoneErr = root.querySelector('[data-phone-error]');

        let isStep1Valid = true;
        let firstInvalid = null;

        if (emailInput) {
          const emailVal = emailInput.value.trim();
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const isNativeValid = emailInput.checkValidity();
          const isValidEmail = Boolean(emailVal) && isNativeValid && emailRegex.test(emailVal);

          if (!isValidEmail) {
            state.data.user_email = '';
            if (emailErr) {
              emailErr.hidden = false;
              emailErr.style.display = 'block';
            }
            emailInput.classList.add('emoto-input-error');
            isStep1Valid = false;
            if (!firstInvalid) firstInvalid = emailInput;
          } else {
            if (emailErr) {
              emailErr.hidden = true;
              emailErr.style.display = 'none';
            }
            emailInput.classList.remove('emoto-input-error');
            state.data.user_email = emailVal;
          }
        }

        if (phoneInput) {
          const phoneVal = phoneInput.value.trim();
          const isValidPhone = Boolean(phoneVal) && phoneVal.replace(/\D/g, '').length >= 7;

          if (!isValidPhone) {
            state.data.user_phone = '';
            if (phoneErr) {
              phoneErr.hidden = false;
              phoneErr.style.display = 'block';
            }
            phoneInput.classList.add('emoto-input-error');
            isStep1Valid = false;
            if (!firstInvalid) firstInvalid = phoneInput;
          } else {
            if (phoneErr) {
              phoneErr.hidden = true;
              phoneErr.style.display = 'none';
            }
            phoneInput.classList.remove('emoto-input-error');
            state.data.user_phone = phoneVal;
          }
        }

        if (!isStep1Valid && firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (typeof firstInvalid.reportValidity === 'function') {
            firstInvalid.reportValidity();
          }
          firstInvalid.focus();
          return false;
        }

        const optinCheckbox = root.querySelector('[data-check-field="marketing_optin"]');
        if (optinCheckbox) state.data.marketing_optin = optinCheckbox.checked;

        saveState();
        return true;
      }

      if (step === 6) {
        let isStep6Valid = true;
        let firstInvalid = null;

        const nameInput = root.querySelector('[data-field="seller_name"]');
        const phoneInput = root.querySelector('[data-field="seller_phone"]');
        const emailInput = root.querySelector('[data-field="seller_email"]');
        const attestationCheckbox = root.querySelector('[data-check-field="seller_attestation"]');
        const attestationCard = root.querySelector('[data-attestation-card]');

        if (nameInput && (!nameInput.value || !nameInput.value.trim())) {
          nameInput.classList.add('emoto-input-error');
          isStep6Valid = false;
          if (!firstInvalid) firstInvalid = nameInput;
        } else if (nameInput) {
          nameInput.classList.remove('emoto-input-error');
        }

        if (phoneInput && (!phoneInput.value || !phoneInput.value.trim())) {
          phoneInput.classList.add('emoto-input-error');
          isStep6Valid = false;
          if (!firstInvalid) firstInvalid = phoneInput;
        } else if (phoneInput) {
          phoneInput.classList.remove('emoto-input-error');
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (
          emailInput &&
          (!emailInput.value || !emailInput.value.trim() || !emailRegex.test(emailInput.value.trim()))
        ) {
          emailInput.classList.add('emoto-input-error');
          isStep6Valid = false;
          if (!firstInvalid) firstInvalid = emailInput;
        } else if (emailInput) {
          emailInput.classList.remove('emoto-input-error');
        }

        if (attestationCheckbox && !attestationCheckbox.checked) {
          if (attestationCard) attestationCard.classList.add('emoto-input-error');
          isStep6Valid = false;
          if (!firstInvalid) firstInvalid = attestationCheckbox;
        } else if (attestationCard) {
          attestationCard.classList.remove('emoto-input-error');
        }

        if (!isStep6Valid && firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (typeof firstInvalid.reportValidity === 'function') {
            firstInvalid.reportValidity();
          }
          firstInvalid.focus();
          return false;
        }

        return true;
      }

      // Universal validation for steps 2+
      const stepContainer = root.querySelector('.emoto-step[data-step="' + step + '"]');
      if (!stepContainer) return true;

      let firstInvalidField = null;

      const fields = stepContainer.querySelectorAll('.emoto-field');
      fields.forEach(function (fieldWrapper) {
        if (fieldWrapper.closest('[hidden]') || fieldWrapper.hidden || fieldWrapper.style.display === 'none') {
          return;
        }

        const label = fieldWrapper.querySelector('label');
        const hasAsterisk = Boolean(label && label.textContent && label.textContent.includes('*'));

        const inputs = fieldWrapper.querySelectorAll('input:not([type="hidden"]), select, textarea');
        inputs.forEach(function (input) {
          if (input.closest('[hidden]') || input.hidden || input.style.display === 'none') {
            return;
          }

          const isRequired = hasAsterisk || input.hasAttribute('required') || input.required;

          if (isRequired) {
            const val = input.value ? input.value.trim() : '';
            if (!val) {
              input.classList.add('emoto-input-error');
              const priceWrap = input.closest('.emoto-price-input-wrap');
              if (priceWrap) priceWrap.classList.add('emoto-input-error');
              if (!firstInvalidField) {
                firstInvalidField = input;
              }
            } else {
              input.classList.remove('emoto-input-error');
              const priceWrap = input.closest('.emoto-price-input-wrap');
              if (priceWrap) priceWrap.classList.remove('emoto-input-error');
            }
          }

          if (input.tagName === 'SELECT' && input.value === 'Other') {
            const otherWrapper = fieldWrapper.querySelector('.emoto-other-input');
            if (otherWrapper && !otherWrapper.hidden) {
              const otherInput = otherWrapper.querySelector('input');
              if (otherInput && !otherInput.value.trim()) {
                otherInput.classList.add('emoto-input-error');
                if (!firstInvalidField) {
                  firstInvalidField = otherInput;
                }
              } else if (otherInput) {
                otherInput.classList.remove('emoto-input-error');
              }
            }
          }
        });
      });

      if (firstInvalidField) {
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof firstInvalidField.reportValidity === 'function') {
          firstInvalidField.reportValidity();
        }
        firstInvalidField.focus();
        return false;
      }

      return true;
    }

    function setStep(step) {
      if (step > 1 && !validateCurrentStep(1)) {
        step = 1;
      }

      state.step = step;
      saveState();

      root.querySelectorAll('.emoto-step').forEach(function (section) {
        section.hidden = Number(section.dataset.step) !== step;
      });

      const progress = root.querySelector('[data-progress-fill]');
      if (progress) {
        progress.style.width = step >= 7 ? '100%' : (step / 6) * 100 + '%';
      }

      const mobileStep = root.querySelector('[data-mobile-step]');
      if (mobileStep) {
        if (step === 7) {
          mobileStep.textContent = 'Preview';
        } else if (step === 8) {
          mobileStep.textContent = 'Publish';
        } else if (step === 9) {
          mobileStep.textContent = 'Under Review';
        } else {
          mobileStep.textContent = 'Step ' + step + ' of 6';
        }
      }

      const mobileBack = root.querySelector('[data-mobile-back]');
      if (mobileBack) {
        mobileBack.hidden = step <= 1;
      }

      root.querySelectorAll('[data-sidebar-step]').forEach(function (item) {
        const itemStep = Number(item.dataset.sidebarStep);
        item.classList.toggle('active', itemStep === step);
        item.classList.toggle('completed', itemStep < step);

        const circle = item.querySelector('.emoto-step-circle');
        if (!circle) return;

        if (itemStep < step) {
          circle.innerHTML = `
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 12L10 17L19 7"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        `;
        } else {
          circle.innerHTML = '';
        }
      });

      if (step === 2) {
        showCategoryForm();
      }

      if (step === 3) {
        showConditionForm();
      }

      if (step === 4) {
        showPhotosForm();
      }

      if (step === 5) {
        showPriceForm();
      }

      if (step === 6) {
        showContactForm();
      }

      if (step === 7) {
        showPreviewScreen();
      }

      if (step === 8) {
        showPricingPackageScreen();
      }

      if (step === 9) {
        showReviewingScreen();
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    /*
     * =========================================================
     * CATEGORY SELECTION
     * =========================================================
     */

    root.querySelectorAll('[data-category]').forEach(function (button) {
      button.addEventListener('click', function () {
        const category = button.dataset.category;
        state.category = category;

        root.querySelectorAll('[data-category]').forEach(function (item) {
          item.classList.toggle('selected', item.dataset.category === category);
        });

        saveState();
      });
    });

    const step1Form = root.querySelector('[data-step1-form]');
    if (step1Form) {
      step1Form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (validateCurrentStep(1)) {
          setStep(2);
          syncDraftToBackend();
        }
      });
    }

    const step1ContinueBtn = root.querySelector('[data-step1-continue]');
    if (step1ContinueBtn) {
      step1ContinueBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (validateCurrentStep(1)) {
          setStep(2);
          syncDraftToBackend();
        }
      });
    }

    const userEmailInput = root.querySelector('[data-field="user_email"]');
    if (userEmailInput) {
      userEmailInput.addEventListener('input', function () {
        const emailErr = root.querySelector('[data-email-error]');
        if (userEmailInput.checkValidity()) {
          if (emailErr) {
            emailErr.hidden = true;
            emailErr.style.display = 'none';
          }
          userEmailInput.classList.remove('emoto-input-error');
        }
      });
    }

    const userPhoneInput = root.querySelector('[data-field="user_phone"]');
    if (userPhoneInput) {
      userPhoneInput.addEventListener('input', function () {
        const phoneErr = root.querySelector('[data-phone-error]');
        if (userPhoneInput.value.trim().length >= 7) {
          if (phoneErr) {
            phoneErr.hidden = true;
            phoneErr.style.display = 'none';
          }
          userPhoneInput.classList.remove('emoto-input-error');
        }
      });
    }

    /*
     * =========================================================
     * FIELD CHANGE & TEXT INPUT
     * =========================================================
     */

    root.addEventListener('change', function (event) {
      const field = event.target.closest('[data-field]');
      if (!field) return;

      if (field.classList && field.classList.contains('emoto-input-error') && field.value) {
        field.classList.remove('emoto-input-error');
      }

      const fieldName = field.dataset.field;
      let val = field.value;
      if (fieldName === 'asking_price') {
        val = val.replace(/\D/g, '');
        state.data.price = val;
      }

      state.data[fieldName] = val;

      if (field.dataset.field === 'brand' || field.dataset.field === 'model' || field.dataset.field === 'color') {
        updateOtherInput(field);
      }

      saveState();
    });

    root.addEventListener('input', function (event) {
      const field = event.target.closest('[data-field]');
      if (!field) return;

      if (field.classList && field.classList.contains('emoto-input-error') && field.value && field.value.trim()) {
        field.classList.remove('emoto-input-error');
      }

      const fieldName = field.dataset.field;
      let val = field.value;
      if (fieldName === 'asking_price') {
        val = val.replace(/\D/g, '');
        state.data.price = val;
      }

      state.data[fieldName] = val;
      saveState();
    });

    /*
     * =========================================================
     * NAVIGATION BUTTONS
     * =========================================================
     */

    function goBack() {
      collectAllCurrentData();
      if (state.step === 8) {
        setStep(7);
        return;
      }
      if (state.step === 7) {
        setStep(6);
        return;
      }
      if (state.step === 9) {
        return;
      }
      if (state.step > 1) {
        setStep(state.step - 1);
      }
    }

    root.querySelectorAll('[data-desktop-back]').forEach(function (button) {
      button.addEventListener('click', goBack);
    });

    root.querySelectorAll('[data-mobile-back]').forEach(function (button) {
      button.addEventListener('click', goBack);
    });

    root.querySelectorAll('[data-change-category]').forEach(function (button) {
      button.addEventListener('click', function () {
        collectFields();
        setStep(1);
      });
    });

    root.querySelectorAll('[data-continue]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        // Validate the current step before advancing
        if (!validateCurrentStep(state.step)) {
          return;
        }

        // Collect all active step fields before moving
        collectAllCurrentData();

        const nextStep = state.step < 6 ? state.step + 1 : 6;
        setStep(nextStep);
        syncDraftToBackend(nextStep);
      });
    });

    root.querySelectorAll('[data-save-exit]').forEach(function (button) {
      button.addEventListener('click', function () {
        collectAllCurrentData();
        syncDraftToBackend(state.step);

        showModal({
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>',
          title: 'Listing Progress Saved',
          subtitle:
            'Your listing progress has been saved automatically. You can return at any time from any device to continue.',
          primaryBtnText: 'Continue Listing',
        });
      });
    });

    /*
     * =========================================================
     * CONDITION FORM
     * =========================================================
     */

    function showConditionForm() {
      updateCategoryVisibility();
      restoreConditionFields();
    }

    function setChoice(fieldName, value, button) {
      state.data[fieldName] = value;
      const container = button.closest('.emoto-condition-question');
      if (container) {
        container.querySelectorAll('[data-choice-field="' + fieldName + '"]').forEach(function (item) {
          item.classList.toggle('is-selected', item.dataset.choiceValue === value);
        });
      }
      updateConditionalFields();
      saveState();
    }

    function updateConditionalFields() {
      root.querySelectorAll('[data-show-if-field]').forEach(function (element) {
        const field = element.dataset.showIfField;
        const expected = element.dataset.showIfValue;
        const actual = state.data[field];
        element.hidden = actual !== expected;
      });

      root.querySelectorAll('[data-hide-if-field]').forEach(function (element) {
        const field = element.dataset.hideIfField;
        const hiddenValue = element.dataset.hideIfValue;
        const actual = state.data[field];
        element.hidden = actual === hiddenValue;
      });
    }

    function collectCheckboxes() {
      const grouped = {};
      root.querySelectorAll('[data-check-field]').forEach(function (checkbox) {
        const field = checkbox.dataset.checkField;
        if (!grouped[field]) {
          grouped[field] = [];
        }
        if (checkbox.checked && !checkbox.closest('[hidden]')) {
          grouped[field].push(checkbox.value);
        }
      });

      Object.keys(grouped).forEach(function (field) {
        state.data[field] = grouped[field];
      });
    }

    function collectRadioFields() {
      root.querySelectorAll('[data-radio-field]').forEach(function (radio) {
        if (!radio.checked || radio.closest('[hidden]')) return;
        state.data[radio.dataset.radioField] = radio.value;
      });
    }

    function collectConditionFields() {
      const stepEl = root.querySelector('.emoto-step-condition');
      if (stepEl && stepEl.hidden) return;

      const form = root.querySelector('.emoto-condition-form');
      if (!form) return;

      form.querySelectorAll('[data-field]').forEach(function (field) {
        if (!field.closest('[hidden]')) {
          state.data[field.dataset.field] = field.value;
        }
      });

      form.querySelectorAll('[data-choice-field]').forEach(function (button) {
        if (button.classList.contains('is-selected') && !button.closest('[hidden]')) {
          state.data[button.dataset.choiceField] = button.dataset.choiceValue;
        }
      });

      collectCheckboxes();
      collectRadioFields();
      saveState();
    }

    function restoreConditionFields() {
      const form = root.querySelector('.emoto-condition-form');
      if (!form) return;

      form.querySelectorAll('[data-field]').forEach(function (field) {
        const key = field.dataset.field;
        if (state.data[key] !== undefined) {
          field.value = state.data[key];
        }
      });

      form.querySelectorAll('[data-choice-field]').forEach(function (button) {
        const field = button.dataset.choiceField;
        const value = button.dataset.choiceValue;
        button.classList.toggle('is-selected', state.data[field] === value);
      });

      form.querySelectorAll('[data-check-field]').forEach(function (checkbox) {
        const field = checkbox.dataset.checkField;
        const values = Array.isArray(state.data[field]) ? state.data[field] : [];
        checkbox.checked = values.includes(checkbox.value);
      });

      form.querySelectorAll('[data-radio-field]').forEach(function (radio) {
        const field = radio.dataset.radioField;
        radio.checked = state.data[field] === radio.value;
      });

      updateConditionalFields();
    }

    root.addEventListener('click', function (event) {
      const button = event.target.closest('[data-choice-field]');
      if (!button) return;

      setChoice(button.dataset.choiceField, button.dataset.choiceValue, button);
    });

    root.addEventListener('change', function (event) {
      const checkbox = event.target.closest('[data-check-field]');
      if (!checkbox) return;

      collectConditionFields();
    });

    /*
     * =========================================================
     * PHOTOS FORM (STEP 4)
     * =========================================================
     */

    const PHOTO_SLOTS = [
      { key: 'front', name: 'Front' },
      { key: 'left_side', name: 'Left side' },
      { key: 'right_side', name: 'Right side' },
      { key: 'rear', name: 'Rear' },
      { key: 'odometer', name: 'Odometer' },
      { key: 'battery_serial', name: 'Battery / serial' },
      { key: 'any_damage', name: 'Any damage' },
      { key: 'whats_included', name: "What's included" },
    ];

    function getPhotos() {
      if (!state.data.photos || typeof state.data.photos !== 'object') {
        state.data.photos = {};
      }
      // Clean up legacy demo placeholders if present in local state
      Object.keys(state.data.photos).forEach(function (key) {
        if (state.data.photos[key] === 'demo') {
          delete state.data.photos[key];
        }
      });
      return state.data.photos;
    }

    function updatePhotosUI() {
      const photos = getPhotos();
      let doneCount = 0;
      let nextEmptySlot = null;

      PHOTO_SLOTS.forEach(function (slot) {
        const slotEl = root.querySelector('.emoto-photo-slot[data-slot="' + slot.key + '"]');
        if (!slotEl) return;

        const boxEl = slotEl.querySelector('[data-slot-box]');
        const previewEl = slotEl.querySelector('[data-slot-preview]');
        const imgEl = slotEl.querySelector('[data-slot-img]');
        const checkEl = slotEl.querySelector('[data-slot-check]');
        const emptyEl = slotEl.querySelector('.emoto-slot-empty');
        const photoData = photos[slot.key];

        if (photoData) {
          doneCount++;
          if (boxEl) boxEl.classList.add('has-photo');
          if (emptyEl) emptyEl.hidden = true;
          if (previewEl) previewEl.hidden = false;
          if (checkEl) checkEl.hidden = false;

          if (imgEl) {
            imgEl.src = photoData;
            imgEl.hidden = false;
          }
        } else {
          if (!nextEmptySlot) nextEmptySlot = slot;
          if (boxEl) boxEl.classList.remove('has-photo');
          if (emptyEl) emptyEl.hidden = false;
          if (previewEl) previewEl.hidden = true;
          if (imgEl) {
            imgEl.src = '';
            imgEl.hidden = true;
          }
          if (checkEl) checkEl.hidden = true;
        }
      });

      const total = PHOTO_SLOTS.length;
      const remaining = total - doneCount;

      const desktopCount = root.querySelector('[data-photo-desktop-count]');
      if (desktopCount) {
        desktopCount.textContent = doneCount + ' of ' + total + ' done';
      }

      const mobileCount = root.querySelector('[data-photo-mobile-count]');
      if (mobileCount) {
        mobileCount.textContent = doneCount + ' of ' + total;
      }

      const mobileProgressFill = root.querySelector('[data-photo-progress-fill]');
      if (mobileProgressFill) {
        mobileProgressFill.style.width = (doneCount / total) * 100 + '%';
      }

      const photosSaveText = root.querySelector('[data-photos-save-text]');
      if (photosSaveText) {
        if (window.innerWidth <= 767 && remaining > 0) {
          photosSaveText.textContent = remaining + ' photos to go · Saved automatically';
        } else {
          photosSaveText.textContent = 'Saved automatically';
        }
      }

      const nextSlotNameEl = root.querySelector('[data-next-slot-name]');
      if (nextSlotNameEl) {
        nextSlotNameEl.textContent = nextEmptySlot ? nextEmptySlot.name : 'All done';
      }

      saveState();
    }

    function showPhotosForm() {
      updateCategoryVisibility();
      updatePhotosUI();
    }

    function handleFileSelect(slotKey, file) {
      if (!file || !file.type.startsWith('image/')) return;

      const reader = new FileReader();
      reader.onload = function (e) {
        const photos = getPhotos();
        photos[slotKey] = e.target.result;
        updatePhotosUI();
      };
      reader.readAsDataURL(file);
    }

    function assignFilesToNextEmptySlots(files) {
      const photos = getPhotos();
      const fileArray = Array.from(files).filter(function (f) {
        return f.type.startsWith('image/');
      });
      let fileIndex = 0;

      for (let i = 0; i < PHOTO_SLOTS.length && fileIndex < fileArray.length; i++) {
        const slot = PHOTO_SLOTS[i];
        if (!photos[slot.key]) {
          const file = fileArray[fileIndex++];
          handleFileSelect(slot.key, file);
        }
      }
    }

    // Bind slot click & file inputs
    root.querySelectorAll('.emoto-photo-slot').forEach(function (slotEl) {
      const slotKey = slotEl.dataset.slot;
      const fileInput = slotEl.querySelector('input[type="file"]');

      slotEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-remove-photo]')) return;
        if (fileInput) fileInput.click();
      });

      if (fileInput) {
        fileInput.addEventListener('change', function (e) {
          if (e.target.files && e.target.files[0]) {
            handleFileSelect(slotKey, e.target.files[0]);
          }
        });
      }

      // Drag and drop for individual slot
      slotEl.addEventListener('dragover', function (e) {
        e.preventDefault();
        const box = slotEl.querySelector('[data-slot-box]');
        if (box) box.style.borderColor = '#111';
      });

      slotEl.addEventListener('dragleave', function () {
        const box = slotEl.querySelector('[data-slot-box]');
        if (box) box.style.borderColor = '';
      });

      slotEl.addEventListener('drop', function (e) {
        e.preventDefault();
        const box = slotEl.querySelector('[data-slot-box]');
        if (box) box.style.borderColor = '';
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleFileSelect(slotKey, e.dataTransfer.files[0]);
        }
      });
    });

    // Remove photo buttons
    root.querySelectorAll('[data-remove-photo]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const slotKey = btn.dataset.removePhoto;
        const photos = getPhotos();
        delete photos[slotKey];
        updatePhotosUI();
      });
    });

    // Mobile Take Next Photo Button
    const takeNextPhotoBtn = root.querySelector('[data-take-next-photo]');
    if (takeNextPhotoBtn) {
      takeNextPhotoBtn.addEventListener('click', function () {
        const photos = getPhotos();
        let nextEmpty = PHOTO_SLOTS.find(function (s) {
          return !photos[s.key];
        });
        if (!nextEmpty) nextEmpty = PHOTO_SLOTS[0];
        const input = root.querySelector('input[data-photo-input="' + nextEmpty.key + '"]');
        if (input) input.click();
      });
    }

    // Main dropzone
    const dropzone = root.querySelector('[data-photo-dropzone]');
    if (dropzone) {
      dropzone.addEventListener('click', function () {
        const photos = getPhotos();
        let nextEmpty = PHOTO_SLOTS.find(function (s) {
          return !photos[s.key];
        });
        if (!nextEmpty) nextEmpty = PHOTO_SLOTS[0];
        const input = root.querySelector('input[data-photo-input="' + nextEmpty.key + '"]');
        if (input) input.click();
      });

      dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        dropzone.classList.add('drag-over');
      });

      dropzone.addEventListener('dragleave', function () {
        dropzone.classList.remove('drag-over');
      });

      dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        dropzone.classList.remove('drag-over');
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          assignFilesToNextEmptySlots(e.dataTransfer.files);
        }
      });
    }

    // Send me the link button (Step 4 Photos)
    const phoneLinkBtn = root.querySelector('[data-send-phone-link]');
    if (phoneLinkBtn) {
      phoneLinkBtn.addEventListener('click', async function () {
        const origBtnText = phoneLinkBtn.innerHTML;
        phoneLinkBtn.disabled = true;
        phoneLinkBtn.innerHTML = `
          <svg class="emoto-btn-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation: emoto-spin 0.8s linear infinite; display: inline-block; vertical-align: middle; margin-right: 4px;"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>
          Generating link...
        `;

        try {
          // 1. Save and sync draft to backend before generating link
          await syncDraftToBackend(4);
        } catch (e) {
          console.warn('[EMOTO Wizard] Notice syncing draft before link generation:', e);
        } finally {
          phoneLinkBtn.disabled = false;
          phoneLinkBtn.innerHTML = origBtnText;
        }

        // 2. Build full shareable resume URL
        const resumeUrl = new URL(window.location.origin + window.location.pathname);
        resumeUrl.searchParams.set('view', 'listing');
        const activeId = state.listing_code || state.listing_id;
        if (activeId) {
          resumeUrl.searchParams.set('listing_id', activeId);
        }
        resumeUrl.searchParams.set('step', '4');
        const finalUrl = resumeUrl.toString();

        const targetEmail = state.data.user_email || state.data.seller_email || '';
        const vehicleTitle = [state.data.year, state.data.brand, state.data.model].filter(Boolean).join(' ') || 'EMOTO Listing';
        const emailSubject = 'Continue Your EMOTO Listing Photos';
        const emailBody = `Here is your personal magic link to resume your EMOTO listing and upload photos:\n\n${finalUrl}\n\nAll your vehicle specifications and progress are safely saved!`;
        const mailtoUrl = `mailto:${targetEmail ? encodeURIComponent(targetEmail) : ''}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

        // 3. Open interactive Modal with Copy Link and Direct Email Sending functionality
        showModal({
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>',
          title: 'Continue on Your Phone',
          subtitle:
            "Open this link on your phone to snap photos directly from your camera into each angle slot. All machine details and progress you've entered are saved.",
          htmlContent: `
            <div class="emoto-magic-modal-body">
              <!-- Option 1: Send directly to Email via Klaviyo -->
              <div class="emoto-magic-card">
                <div class="emoto-magic-card-header">
                  <svg class="emoto-magic-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span class="emoto-magic-card-title">Send Link to Email</span>
                </div>
                <div class="emoto-magic-input-group">
                  <input type="email" class="emoto-magic-input" id="emoto-phone-email-input" value="${targetEmail}" placeholder="Enter your email address...">
                  <button type="button" class="emoto-magic-btn" id="emoto-phone-email-btn" data-magic-email-send>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                    <span class="emoto-email-btn-text">Send Link</span>
                  </button>
                </div>
                <div class="emoto-magic-feedback" id="emoto-magic-email-feedback" style="display:none;"></div>
              </div>

              <div class="emoto-magic-divider">
                <span>OR</span>
              </div>

              <!-- Option 2: Copy Direct Link -->
              <div class="emoto-magic-card">
                <div class="emoto-magic-card-header">
                  <svg class="emoto-magic-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  <span class="emoto-magic-card-title">Copy Direct Link</span>
                </div>
                <div class="emoto-magic-input-group">
                  <input type="text" readonly class="emoto-magic-input emoto-magic-input-readonly" value="${finalUrl}" id="emoto-phone-link-input" onclick="this.select()">
                  <button type="button" class="emoto-magic-btn" id="emoto-magic-copy-btn" data-magic-copy>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="emoto-copy-icon">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    <span class="emoto-copy-btn-text">Copy Link</span>
                  </button>
                </div>
                <div class="emoto-magic-feedback emoto-magic-feedback-copy" id="emoto-magic-toast" style="display:none;">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#108043" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Link copied to clipboard! Open it in your mobile browser.</span>
                </div>
              </div>
            </div>
          `,
          primaryBtnText: 'Done',
        });

        // 4. Attach Event Listeners for Copy & Direct Email Dispatch
        requestAnimationFrame(() => {
          const copyBtn = root.querySelector('[data-magic-copy]');
          const inputEl = root.querySelector('#emoto-phone-link-input');
          const toastEl = root.querySelector('#emoto-magic-toast');
          const emailSendBtn = root.querySelector('[data-magic-email-send]');
          const emailInput = root.querySelector('#emoto-phone-email-input');
          const feedbackEl = root.querySelector('#emoto-magic-email-feedback');

          // Copy Link Listener
          if (copyBtn) {
            copyBtn.addEventListener('click', async function (e) {
              e.preventDefault();
              let copied = false;

              if (navigator.clipboard && navigator.clipboard.writeText) {
                try {
                  await navigator.clipboard.writeText(finalUrl);
                  copied = true;
                } catch (err) {
                  console.warn('Clipboard API write failed, trying fallback', err);
                }
              }

              if (!copied && inputEl) {
                inputEl.focus();
                inputEl.select();
                try {
                  document.execCommand('copy');
                  copied = true;
                } catch (err) {
                  console.error('execCommand copy failed', err);
                }
              }

              if (copied) {
                copyBtn.classList.add('is-copied');
                const btnText = copyBtn.querySelector('.emoto-copy-btn-text');
                if (btnText) {
                  btnText.innerHTML = `
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display:inline-block; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    <span>Copied!</span>
                  `;
                }
                if (toastEl) {
                  toastEl.style.display = 'flex';
                }
                setTimeout(() => {
                  if (copyBtn) {
                    copyBtn.classList.remove('is-copied');
                    if (btnText) btnText.textContent = 'Copy Link';
                  }
                }, 3500);
              }
            });
          }

          // Direct Email Send Listener (Klaviyo)
          if (emailSendBtn && emailInput) {
            emailSendBtn.addEventListener('click', async function (e) {
              e.preventDefault();
              const emailVal = emailInput.value.trim().toLowerCase();

              if (!emailVal || !emailVal.includes('@')) {
                if (feedbackEl) {
                  feedbackEl.className = 'emoto-magic-feedback is-error';
                  feedbackEl.innerHTML = `
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <span>Please enter a valid email address.</span>
                  `;
                  feedbackEl.style.display = 'flex';
                }
                emailInput.focus();
                return;
              }

              const btnText = emailSendBtn.querySelector('.emoto-email-btn-text');
              const origText = btnText ? btnText.textContent : 'Send Link';
              emailSendBtn.disabled = true;
              if (btnText) {
                btnText.innerHTML = `
                  <svg class="emoto-btn-spin" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation: emoto-spin 0.8s linear infinite; display: inline-block; vertical-align: middle; margin-right: 4px;"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>
                  Sending...
                `;
              }

              try {
                const resp = await fetch(API_ENDPOINT, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    action_type: 'send_magic_link',
                    email: emailVal,
                    listing_id: state.listing_id || state.listing_code || '',
                    resume_url: finalUrl,
                    step: 4,
                    seller_name: state.data.seller_name || '',
                    vehicle_title: vehicleTitle,
                  }),
                });

                const resData = await resp.json();
                if (resData.success) {
                  if (btnText) {
                    btnText.innerHTML = `
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display:inline-block; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      <span>Link Sent!</span>
                    `;
                  }
                  emailSendBtn.classList.add('is-sent');
                  if (feedbackEl) {
                    feedbackEl.className = 'emoto-magic-feedback is-success';
                    feedbackEl.innerHTML = `
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#108043" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      <span>Magic link sent to <strong>${emailVal}</strong>! Open the email on your phone to resume and upload photos.</span>
                    `;
                    feedbackEl.style.display = 'flex';
                  }
                } else {
                  if (btnText) btnText.textContent = origText;
                  if (feedbackEl) {
                    feedbackEl.className = 'emoto-magic-feedback is-error';
                    feedbackEl.innerHTML = `
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                      <span>${resData.error || 'Failed to dispatch email. Please use Copy Link instead.'}</span>
                    `;
                    feedbackEl.style.display = 'flex';
                  }
                }
              } catch (err) {
                if (btnText) btnText.textContent = origText;
                if (feedbackEl) {
                  feedbackEl.className = 'emoto-magic-feedback is-error';
                  feedbackEl.innerHTML = `
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <span>Network error sending email. Please copy the link above.</span>
                  `;
                  feedbackEl.style.display = 'flex';
                }
              } finally {
                emailSendBtn.disabled = false;
              }
            });
          }
        });
      });
    }

    // Add video link
    const videoLink = root.querySelector('[data-add-video-link]');
    if (videoLink) {
      videoLink.addEventListener('click', function (e) {
        e.preventDefault();
        const currentVal = state.data.walkaround_video || '';
        showModal({
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>',
          title: 'Add Walkaround Video',
          subtitle:
            'Add a YouTube or Vimeo link to show interested buyers an exhaustive video walkaround of your machine.',
          htmlContent: `
            <div style="margin-bottom: 8px;">
              <input type="url" class="emoto-modal-input" data-modal-video-input placeholder="https://youtube.com/watch" value="${currentVal}">
            </div>
          `,
          primaryBtnText: 'Save Video Link',
          secondaryBtnText: 'Cancel',
          onPrimary: function (modalEl) {
            const input = modalEl.querySelector('[data-modal-video-input]');
            if (input) {
              state.data.walkaround_video = input.value.trim();
              saveState();
            }
          },
        });
      });
    }

    /*
     * =========================================================
     * PRICE & LOCATION FORM (STEP 5)
     * =========================================================
     */

    function formatPriceNumber(val) {
      if (!val) return '';
      const digits = val.toString().replace(/\D/g, '');
      if (!digits) return '';
      return Number(digits).toLocaleString('en-US');
    }

    function showPriceForm() {
      updateCategoryVisibility();

      // Dynamic Valuation Card data
      const cat = state.category || 'dirt_bike';
      const modelEl = root.querySelector('[data-valuation-model]');
      if (modelEl) {
        let modelText = 'Light Bees';
        if (state.data.model && state.data.model !== 'Other') {
          modelText = state.data.model.endsWith('s') ? state.data.model : state.data.model + 's';
        } else if (cat === 'e_bike') {
          modelText = 'E-Bikes';
        } else if (cat === 'motorcycle') {
          modelText = 'Motorcycles';
        } else if (cat === 'scooter') {
          modelText = 'Scooters';
        } else if (cat === 'golf_cart') {
          modelText = 'Golf Carts';
        }
        const yearText = state.data.year ? (state.data.year === 'Older' ? 'Older' : state.data.year) : '2022–2024';
        modelEl.textContent = yearText + ' ' + modelText;
      }

      restorePriceFields();
    }

    function collectPriceFields() {
      const stepEl = root.querySelector('.emoto-step-price');
      if (stepEl && stepEl.hidden) return;

      const form = root.querySelector('.emoto-price-form');
      if (!form) return;

      const priceInput = form.querySelector('[data-field="asking_price"]');
      if (priceInput) {
        const raw = priceInput.value.replace(/\D/g, '');
        if (raw) {
          state.data.asking_price = raw;
          state.data.price = raw;
        }
      }

      const zipInput = form.querySelector('[data-field="zip_code"]');
      if (zipInput && zipInput.value.trim()) {
        state.data.zip_code = zipInput.value.trim();
        state.data.location_zip = zipInput.value.trim();
      }

      const firmSelect = form.querySelector('select[data-field="is_firm"]');
      if (firmSelect && firmSelect.value) {
        state.data.is_firm = firmSelect.value;
      }
      const firmBtn = form.querySelector('.emoto-firm-mobile-group [data-choice-field="is_firm"].is-selected');
      if (firmBtn && firmBtn.dataset.choiceValue) {
        state.data.is_firm = firmBtn.dataset.choiceValue;
      }

      const fulfillSelect = form.querySelector('select[data-field="fulfillment_method"]');
      if (fulfillSelect && fulfillSelect.value) {
        state.data.fulfillment_method = fulfillSelect.value;
      }
      const fulfillBtn = form.querySelector('.emoto-fulfillment-mobile-group [data-choice-field="fulfillment_method"].is-selected');
      if (fulfillBtn && fulfillBtn.dataset.choiceValue) {
        state.data.fulfillment_method = fulfillBtn.dataset.choiceValue;
      }

      const includedTextarea = form.querySelector('[data-field="whats_included"]');
      if (includedTextarea && includedTextarea.value !== undefined) {
        state.data.whats_included = includedTextarea.value;
        state.data.accessories_included = includedTextarea.value;
      }

      saveState();
    }

    function restorePriceFields() {
      const form = root.querySelector('.emoto-price-form');
      if (!form) return;

      const priceInput = form.querySelector('[data-field="asking_price"]');
      if (priceInput && state.data.asking_price !== undefined) {
        priceInput.value = formatPriceNumber(state.data.asking_price);
      }

      const zipInput = form.querySelector('[data-field="zip_code"]');
      if (zipInput && state.data.zip_code !== undefined) {
        zipInput.value = state.data.zip_code;
      }

      const firmVal = state.data.is_firm || 'Negotiable';
      state.data.is_firm = firmVal;
      const firmSelect = form.querySelector('select[data-field="is_firm"]');
      if (firmSelect) firmSelect.value = firmVal;
      form.querySelectorAll('[data-choice-field="is_firm"]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.choiceValue === firmVal);
      });

      const fulfillVal = state.data.fulfillment_method || 'Both';
      state.data.fulfillment_method = fulfillVal;
      const fulfillSelect = form.querySelector('select[data-field="fulfillment_method"]');
      if (fulfillSelect) fulfillSelect.value = fulfillVal;
      form.querySelectorAll('[data-choice-field="fulfillment_method"]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.choiceValue === fulfillVal);
      });

      const includedTextarea = form.querySelector('[data-field="whats_included"]');
      if (includedTextarea && state.data.whats_included !== undefined) {
        includedTextarea.value = state.data.whats_included;
      }
    }

    // Step 5 Event Listeners
    const priceInputField = root.querySelector('.emoto-price-input[data-field="asking_price"]');
    if (priceInputField) {
      priceInputField.addEventListener('input', function () {
        const raw = priceInputField.value.replace(/\D/g, '');
        if (raw) {
          priceInputField.value = Number(raw).toLocaleString('en-US');
          state.data.asking_price = raw;
        } else {
          priceInputField.value = '';
          state.data.asking_price = '';
        }
        if (priceInputField.value) {
          const wrap = priceInputField.closest('.emoto-price-input-wrap');
          if (wrap) wrap.classList.remove('emoto-input-error');
        }
        saveState();
      });
    }

    root.addEventListener('click', function (e) {
      const btn = e.target.closest('.emoto-step-price [data-choice-field]');
      if (!btn) return;

      const fieldName = btn.dataset.choiceField;
      const val = btn.dataset.choiceValue;
      state.data[fieldName] = val;

      const container = btn.closest('.emoto-firm-mobile-group, .emoto-fulfillment-mobile-group');
      if (container) {
        container.querySelectorAll('[data-choice-field="' + fieldName + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.choiceValue === val);
        });
      }

      const desktopSelect = root.querySelector('.emoto-step-price select[data-field="' + fieldName + '"]');
      if (desktopSelect) {
        desktopSelect.value = val;
      }

      saveState();
    });

    root.querySelectorAll('.emoto-step-price select').forEach(function (select) {
      select.addEventListener('change', function () {
        const fieldName = select.dataset.field;
        const val = select.value;
        state.data[fieldName] = val;

        root.querySelectorAll('.emoto-step-price [data-choice-field="' + fieldName + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.choiceValue === val);
        });

        saveState();
      });
    });

    /*
     * =========================================================
     * CONTACT & ATTESTATION FORM (STEP 6)
     * =========================================================
     */

    function showContactForm() {
      updateCategoryVisibility();

      // Pre-fill email and phone from step 1 if not yet provided
      if (!state.data.seller_email && state.data.user_email) {
        state.data.seller_email = state.data.user_email;
      }
      if (!state.data.seller_phone && state.data.user_phone) {
        state.data.seller_phone = state.data.user_phone;
      }

      restoreContactFields();
    }

    function collectContactFields() {
      const stepEl = root.querySelector('.emoto-step-contact');
      if (stepEl && stepEl.hidden) return;

      const form = root.querySelector('.emoto-contact-form');
      if (!form) return;

      const nameInput = form.querySelector('[data-field="seller_name"]');
      if (nameInput && nameInput.value.trim()) {
        state.data.seller_name = nameInput.value.trim();
      }

      const phoneInput = form.querySelector('[data-field="seller_phone"]');
      if (phoneInput && phoneInput.value.trim()) {
        state.data.seller_phone = phoneInput.value.trim();
      }

      const emailInput = form.querySelector('[data-field="seller_email"]');
      if (emailInput && emailInput.value.trim()) {
        state.data.seller_email = emailInput.value.trim();
      }

      const prefBtn = form.querySelector('[data-choice-field="preferred_contact"].is-selected');
      if (prefBtn && prefBtn.dataset.choiceValue) {
        state.data.preferred_contact = prefBtn.dataset.choiceValue;
      }

      const attestationCheckbox = form.querySelector('[data-check-field="seller_attestation"]');
      if (attestationCheckbox) {
        state.data.seller_attestation = attestationCheckbox.checked;
      }

      saveState();
    }

    function restoreContactFields() {
      const form = root.querySelector('.emoto-contact-form');
      if (!form) return;

      const nameInput = form.querySelector('[data-field="seller_name"]');
      if (nameInput && state.data.seller_name !== undefined) {
        nameInput.value = state.data.seller_name;
      }

      const phoneInput = form.querySelector('[data-field="seller_phone"]');
      if (phoneInput) {
        if (state.data.seller_phone !== undefined) {
          phoneInput.value = state.data.seller_phone;
        } else if (state.data.user_phone) {
          phoneInput.value = state.data.user_phone;
        }
      }

      const emailInput = form.querySelector('[data-field="seller_email"]');
      if (emailInput) {
        if (state.data.seller_email !== undefined) {
          emailInput.value = state.data.seller_email;
        } else if (state.data.user_email) {
          emailInput.value = state.data.user_email;
        }
      }

      const attestationCheckbox = form.querySelector('[data-check-field="seller_attestation"]');
      if (attestationCheckbox && state.data.seller_attestation !== undefined) {
        attestationCheckbox.checked = !!state.data.seller_attestation;
      }
    }

    // Step 6 Event Listeners
    const attestationCheckboxEl = root.querySelector('[data-check-field="seller_attestation"]');
    if (attestationCheckboxEl) {
      attestationCheckboxEl.addEventListener('change', function () {
        const card = root.querySelector('[data-attestation-card]');
        if (attestationCheckboxEl.checked && card) {
          card.classList.remove('emoto-input-error');
        }
        collectContactFields();
      });
    }

    const sellerTermsLink = root.querySelector('[data-seller-terms]');
    if (sellerTermsLink) {
      sellerTermsLink.addEventListener('click', function (e) {
        e.preventDefault();
        showModal({
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>',
          title: 'EMOTO Seller Terms',
          subtitle: 'Transparent terms designed to keep buying and selling simple, secure, and direct.',
          htmlContent: `
            <div class="emoto-modal-terms-list">
              <div class="emoto-modal-term-item">
                <span class="emoto-modal-term-num">1.</span>
                <span><strong>Accurate Representation:</strong> You confirm that all entered details, modifications, title status, and photos are truthful and accurately describe the machine.</span>
              </div>
              <div class="emoto-modal-term-item">
                <span class="emoto-modal-term-num">2.</span>
                <span><strong>Ownership & Right to Sell:</strong> You certify that you are the rightful owner or legally authorized representative with the title/MCO required to sell this vehicle.</span>
              </div>
              <div class="emoto-modal-term-item">
                <span class="emoto-modal-term-num">3.</span>
                <span><strong>Platform Listing Model:</strong> EMOTO provides the platform to connect buyers and sellers. EMOTO does not intermediate funds, hold escrow, or deduct commission fees from your sale price.</span>
              </div>
              <div class="emoto-modal-term-item">
                <span class="emoto-modal-term-num">4.</span>
                <span><strong>Buyer Inquiries:</strong> Your contact details are never shown publicly; verified buyer inquiries will be forwarded securely directly to your email and phone.</span>
              </div>
            </div>
          `,
          primaryBtnText: 'I Understand & Agree',
        });
      });
    }

    const finishListingBtn = root.querySelector('[data-finish-listing]');
    if (finishListingBtn) {
      finishListingBtn.addEventListener('click', function (e) {
        e.preventDefault();
        collectContactFields();

        if (!validateCurrentStep(6)) {
          return;
        }

        state.listing_completed = true;
        collectAllCurrentData();
        syncDraftToBackend(6, true);
        setStep(7);
      });
    }

    /*
     * =========================================================
     * PREVIEW LISTING SCREEN (STEP 7)
     * =========================================================
     */

    function showPreviewScreen() {
      // 1. Render immediately from local state
      renderPreviewData(null, null);

      // 2. Hydrate from backend database if listing_id exists
      if (state.listing_id) {
        fetch(API_ENDPOINT + '?listing_id=' + encodeURIComponent(state.listing_id))
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (resData) {
            if (resData && resData.success && resData.listing) {
              console.log('[Preview fetched from DB]:', resData);
              renderPreviewData(resData.listing, resData.seller);
            }
          })
          .catch(function (err) {
            console.warn('[Preview fetch warning]:', err);
          });
      }
    }

    function renderPreviewData(dbListing, dbSeller) {
      const data = state.data || {};
      const cat = state.category || (dbListing && dbListing.category) || 'dirt_bike';
      const catName = CATEGORY_NAMES[cat] || 'Ride';

      // 1. Title: Year Brand Model
      const year = data.year || (dbListing && dbListing.year) || '2023';
      const brand =
        data.brand === 'Other'
          ? data.other_brand || 'Custom'
          : data.brand || (dbListing && dbListing.brand) || 'Sur-Ron';
      const model =
        data.model === 'Other'
          ? data.other_model || 'Custom'
          : data.model || (dbListing && dbListing.model) || (cat === 'dirt_bike' ? 'Light Bee X' : catName);
      const fullTitle = [year, brand, model].filter(Boolean).join(' ');

      const titleEl = root.querySelector('[data-preview-title]');
      if (titleEl) titleEl.textContent = fullTitle;

      // 2. Badge & Location
      const zip = data.zip_code || (dbListing && dbListing.location_zip) || '33602';
      const city = (dbListing && dbListing.location_city) || data.city || 'Tampa';
      const stateLoc = (dbListing && dbListing.location_state) || data.state || 'FL';
      const locText = city && stateLoc ? city + ', ' + stateLoc : zip ? 'ZIP ' + zip : 'Tampa, FL';
      const fulfillment = data.fulfillment_method || (dbListing && dbListing.shipping_option) || 'Both';
      const shipText =
        fulfillment === 'Pickup'
          ? 'Local pickup only'
          : fulfillment === 'Ship'
          ? 'Ships nationwide'
          : 'Ships nationwide';

      const locShipEl = root.querySelector('[data-preview-location-ship]');
      if (locShipEl) locShipEl.textContent = locText + ' · ' + shipText;

      const badgeEl = root.querySelector('[data-preview-badge]');
      if (badgeEl) badgeEl.textContent = data.condition_rating === 'Brand new' ? 'NEW' : 'USED';

      // 3. Price & Negotiability
      const rawPrice = data.asking_price || (dbListing && dbListing.price) || 2400;
      const numPrice = Number(String(rawPrice).replace(/\D/g, '')) || 2400;
      const priceEl = root.querySelector('[data-preview-price]');
      if (priceEl) priceEl.textContent = '$' + numPrice.toLocaleString('en-US');

      const isFirmVal =
        data.is_firm || (dbListing && dbListing.price_negotiable_bool === false ? 'Firm' : 'Negotiable');
      const negEl = root.querySelector('[data-preview-negotiable]');
      if (negEl) negEl.textContent = isFirmVal === 'Firm' ? 'firm' : 'negotiable';

      // 4. Specs
      // Mileage
      const rawMileage = data.mileage || data.usage_amount || (dbListing && dbListing.mileage) || 1240;
      const mileageText = Number(String(rawMileage).replace(/\D/g, '') || 1240).toLocaleString('en-US') + ' mi';
      const mileageEl = root.querySelector('[data-preview-mileage]');
      if (mileageEl) mileageEl.textContent = mileageText;
      const mobMileageEl = root.querySelector('[data-preview-mobile-mileage]');
      if (mobMileageEl) mobMileageEl.textContent = mileageText;

      // Battery
      let batteryText = 'Replaced Mar 2025';
      if (data.battery_replaced) {
        batteryText = 'Replaced ' + data.battery_replaced;
      } else if (data.battery_health_pct) {
        batteryText = 'Original, ' + data.battery_health_pct + '% health';
      } else if (data.battery_condition) {
        batteryText = data.battery_condition;
      } else if (data.battery_cycle_count) {
        batteryText = data.battery_cycle_count + ' cycles';
      }
      const batteryEl = root.querySelector('[data-preview-battery]');
      if (batteryEl) batteryEl.textContent = batteryText;
      const mobBatteryEl = root.querySelector('[data-preview-mobile-battery]');
      if (mobBatteryEl) mobBatteryEl.textContent = batteryText;

      // Modifications
      let modsText = 'Yes — 3 listed';
      if (Array.isArray(data.modifications) && data.modifications.length > 0) {
        modsText = 'Yes — ' + data.modifications.length + ' listed';
      } else if (data.has_mods === 'no') {
        modsText = 'None (All stock)';
      } else if (data.has_mods === 'yes') {
        modsText = 'Yes — 3 listed';
      }
      const modsEl = root.querySelector('[data-preview-mods]');
      if (modsEl) modsEl.textContent = modsText;
      const mobModsEl = root.querySelector('[data-preview-mobile-mods]');
      if (mobModsEl) mobModsEl.textContent = modsText;

      // Title / MCO
      let titleMcoText = 'MCO, never titled';
      if (data.title_status) {
        titleMcoText = data.title_status;
      } else if (data.has_title === 'yes') {
        titleMcoText = 'Clean title in hand';
      } else if (data.has_title === 'no') {
        titleMcoText = 'MCO, never titled';
      } else if (dbListing && dbListing.title_status) {
        titleMcoText = dbListing.title_status;
      }
      const titleMcoEl = root.querySelector('[data-preview-title-status]');
      if (titleMcoEl) titleMcoEl.textContent = titleMcoText;
      const mobTitleMcoEl = root.querySelector('[data-preview-mobile-title-status]');
      if (mobTitleMcoEl) mobTitleMcoEl.textContent = titleMcoText;

      // Bought from
      let boughtText = data.purchased_from || data.bought_from || data.ownership_history || 'Authorized US dealer';
      const boughtEl = root.querySelector('[data-preview-bought-from]');
      if (boughtEl) boughtEl.textContent = boughtText;
      const mobBoughtEl = root.querySelector('[data-preview-mobile-bought-from]');
      if (mobBoughtEl) mobBoughtEl.textContent = boughtText.replace('Authorized ', '');

      // Accidents
      let accText = 'None reported';
      if (data.accident_history_notes) {
        accText = data.accident_history_notes;
      } else if (
        data.accident_history === 'no' ||
        data.has_accidents === 'no' ||
        (dbListing && dbListing.accident_history_bool === false)
      ) {
        accText = 'None reported';
      } else if (
        data.accident_history === 'yes' ||
        data.has_accidents === 'yes' ||
        (dbListing && dbListing.accident_history_bool === true)
      ) {
        accText = 'Minor tip-over';
      }
      const accEl = root.querySelector('[data-preview-accidents]');
      if (accEl) accEl.textContent = accText;
      const mobAccEl = root.querySelector('[data-preview-mobile-accidents]');
      if (mobAccEl) mobAccEl.textContent = accText === 'None reported' ? 'None' : accText;

      // 5. Description
      let descText =
        data.whats_included || data.reason_for_selling || (dbListing && dbListing.accessories_included) || '';
      if (!descText) {
        descText =
          "Includes charger and spare sprocket. Ridden trails only, never raced. Selling because I've moved up to a full-size bike.";
      }
      const descEl = root.querySelector('[data-preview-desc-text]');
      if (descEl) descEl.textContent = descText;

      // 6. Photos (Interactive Slider)
      const photosObj = data.photos || {};
      const photoKeys = Object.keys(photosObj).filter(function (k) {
        return photosObj[k] && photosObj[k] !== 'demo' && String(photosObj[k]).trim().length > 0;
      });
      const photoUrls = photoKeys.map(function (k) {
        return photosObj[k];
      });

      const galleryEl = root.querySelector('[data-preview-gallery]');
      const mainImg = root.querySelector('[data-preview-img-main]');
      const mainPlaceholder = root.querySelector('[data-preview-placeholder-main]');
      const prevBtn = root.querySelector('[data-preview-slide-prev]');
      const nextBtn = root.querySelector('[data-preview-slide-next]');
      const counterBadge = root.querySelector('[data-preview-counter-badge]');
      const dotsStrip = root.querySelector('[data-preview-dots-strip]');
      const count = photoUrls.length;

      let currentSlide = 0;

      function updateSlideDisplay() {
        if (count === 0) {
          if (mainImg) mainImg.hidden = true;
          if (mainPlaceholder) mainPlaceholder.hidden = false;
          if (prevBtn) prevBtn.hidden = true;
          if (nextBtn) nextBtn.hidden = true;
          if (counterBadge) counterBadge.hidden = true;
          if (dotsStrip) {
            dotsStrip.hidden = true;
            dotsStrip.innerHTML = '';
          }
          return;
        }

        if (currentSlide >= count) currentSlide = 0;
        if (currentSlide < 0) currentSlide = count - 1;

        if (mainImg) {
          mainImg.style.opacity = '0.4';
          mainImg.src = photoUrls[currentSlide];
          mainImg.hidden = false;
          setTimeout(function () {
            if (mainImg) mainImg.style.opacity = '1';
          }, 50);
        }
        if (mainPlaceholder) mainPlaceholder.hidden = true;

        if (count === 1) {
          if (prevBtn) prevBtn.hidden = true;
          if (nextBtn) nextBtn.hidden = true;
          if (counterBadge) counterBadge.hidden = true;
          if (dotsStrip) {
            dotsStrip.hidden = true;
            dotsStrip.innerHTML = '';
          }
        } else {
          if (prevBtn) prevBtn.hidden = false;
          if (nextBtn) nextBtn.hidden = false;
          if (counterBadge) {
            counterBadge.hidden = false;
            counterBadge.textContent = (currentSlide + 1) + ' / ' + count;
          }
          if (dotsStrip) {
            dotsStrip.hidden = false;
            let thumbsHtml = '';
            for (let i = 0; i < count; i++) {
              const isActive = i === currentSlide;
              thumbsHtml += '<button type="button" class="emoto-preview-thumb-dot' + (isActive ? ' active' : '') + '" data-slide-index="' + i + '" aria-label="Photo ' + (i + 1) + '">';
              thumbsHtml += '<img src="' + photoUrls[i] + '" alt="Thumb ' + (i + 1) + '" />';
              thumbsHtml += '</button>';
            }
            dotsStrip.innerHTML = thumbsHtml;

            dotsStrip.querySelectorAll('.emoto-preview-thumb-dot').forEach(function (dotBtn) {
              dotBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                currentSlide = Number(dotBtn.dataset.slideIndex) || 0;
                updateSlideDisplay();
              });
            });
          }
        }
      }

      // Initial slider render
      updateSlideDisplay();

      // Prev & Next button handlers
      if (prevBtn) {
        prevBtn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          currentSlide = (currentSlide - 1 + count) % count;
          updateSlideDisplay();
        };
      }

      if (nextBtn) {
        nextBtn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          currentSlide = (currentSlide + 1) % count;
          updateSlideDisplay();
        };
      }

      // Photos count in checklist
      const photoCheckEl = root.querySelector('[data-publish-photo-check]');
      if (photoCheckEl) {
        photoCheckEl.textContent = count > 0 ? count + ' of 8 photos' : '0 of 8 photos';
      }
    }

    // Keep editing & section click listeners
    root.querySelectorAll('[data-keep-editing]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setStep(6);
      });
    });

    root.querySelectorAll('[data-edit-step]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        const targetStep = Number(el.dataset.editStep);
        if (targetStep >= 1 && targetStep <= 6) {
          setStep(targetStep);
        }
      });
    });

    // Step 7 -> Step 8 (Publish button)
    root.querySelectorAll('[data-publish-listing-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setStep(8);
      });
    });

    /*
     * =========================================================
     * STEP 8: PRICING PACKAGE SCREEN
     * =========================================================
     */

    let selectedPackage = '3_months';
    let selectedPrice = 50;
    let isSelectedPackageFree = false;

    let PACKAGE_PRICES = {
      '1_month': { price: 20, originalPrice: 35, isFree: false, name: '1 month', durationDesc: 'full 1 month' },
      '3_months': { price: 50, originalPrice: 90, isFree: false, name: '3 months', durationDesc: 'full 3 months' },
      '6_months': { price: 85, originalPrice: 150, isFree: false, name: '6 months', durationDesc: 'full 6 months' },
    };

    async function fetchPackagePricing() {
      try {
        const res = await fetch(PACKAGES_ENDPOINT);
        const data = await res.json();
        if (data.success && data.packages) {
          if (data.packages['1_month']) {
            PACKAGE_PRICES['1_month'].price = data.packages['1_month'].effective_price !== undefined ? data.packages['1_month'].effective_price : 20;
            PACKAGE_PRICES['1_month'].originalPrice = data.packages['1_month'].original_price || 20;
            PACKAGE_PRICES['1_month'].isFree = !!data.packages['1_month'].is_free;
          }
          if (data.packages['3_months']) {
            PACKAGE_PRICES['3_months'].price = data.packages['3_months'].effective_price !== undefined ? data.packages['3_months'].effective_price : 50;
            PACKAGE_PRICES['3_months'].originalPrice = data.packages['3_months'].original_price || 50;
            PACKAGE_PRICES['3_months'].isFree = !!data.packages['3_months'].is_free;
          }
          if (data.packages['6_months']) {
            PACKAGE_PRICES['6_months'].price = data.packages['6_months'].effective_price !== undefined ? data.packages['6_months'].effective_price : 85;
            PACKAGE_PRICES['6_months'].originalPrice = data.packages['6_months'].original_price || 85;
            PACKAGE_PRICES['6_months'].isFree = !!data.packages['6_months'].is_free;
          }

          // Update banner if custom promo text
          const bannerEl = root.querySelector('.emoto-founder-text');
          if (bannerEl && data.promo_banner_text) {
            bannerEl.innerHTML = `<strong>${data.promo_banner_text}</strong>`;
          }

          // Update each card's price display in the DOM
          root.querySelectorAll('.emoto-tier-card').forEach(function (card) {
            const pkgKey = card.dataset.package;
            const pkgInfo = PACKAGE_PRICES[pkgKey];
            if (!pkgInfo) return;

            const curPriceEl = card.querySelector('.emoto-tier-current-price');
            const origPriceEl = card.querySelector('.emoto-tier-original-price');

            if (pkgInfo.isFree || pkgInfo.price === 0) {
              if (curPriceEl) {
                curPriceEl.textContent = 'FREE';
                curPriceEl.style.color = '#2e6830';
              }
              if (origPriceEl) {
                origPriceEl.textContent = '$' + pkgInfo.originalPrice;
                origPriceEl.style.display = 'inline';
              }
            } else if (pkgInfo.price < pkgInfo.originalPrice) {
              if (curPriceEl) {
                curPriceEl.textContent = '$' + pkgInfo.price;
                curPriceEl.style.color = '#cf2942';
              }
              if (origPriceEl) {
                origPriceEl.textContent = '$' + pkgInfo.originalPrice;
                origPriceEl.style.display = 'inline';
              }
            } else {
              if (curPriceEl) {
                curPriceEl.textContent = '$' + pkgInfo.price;
                curPriceEl.style.color = '';
              }
              if (origPriceEl) {
                origPriceEl.style.display = 'none';
              }
            }
          });

          updatePackageUI(selectedPackage);
        }
      } catch (e) {
        console.warn('Failed to fetch package pricing:', e);
      }
    }

    function updatePackageUI(pkg) {
      selectedPackage = pkg;
      const pkgInfo = PACKAGE_PRICES[pkg] || { price: 50, isFree: false };
      selectedPrice = pkgInfo.price;
      isSelectedPackageFree = !!pkgInfo.isFree || selectedPrice === 0;

      state.data.package_tier = selectedPackage;
      state.data.pricing_tier = isSelectedPackageFree ? '$0 (Free)' : '$' + selectedPrice;
      saveState();

      root.querySelectorAll('.emoto-tier-card').forEach(function (card) {
        const cardPkg = card.dataset.package;
        const isMatch = cardPkg === pkg;
        card.classList.toggle('is-selected', isMatch);
        const radioDot = card.querySelector('.emoto-radio-dot');
        if (radioDot) radioDot.style.display = isMatch ? 'block' : 'none';
      });

      const submitBtn = root.querySelector('[data-pay-submit-btn]');
      if (submitBtn) {
        submitBtn.textContent = isSelectedPackageFree ? 'Submit Free Listing' : `Continue to Checkout ($${selectedPrice})`;
      }

      const creditDesc = root.querySelector('[data-credit-desc]');
      if (creditDesc) {
        if (isSelectedPackageFree) {
          creditDesc.textContent = 'Launch promotion active: Your listing is 100% free with no upfront fee or commissions!';
        } else {
          creditDesc.textContent =
            'Your $' +
            selectedPrice +
            " listing fee comes straight back as store credit the moment you publish. Spend it on anything we sell — a new machine, a battery, a set of tires. It doesn't expire.";
        }
      }
    }

    function showPricingPackageScreen() {
      const currentPkg = state.data.package_tier || selectedPackage || '3_months';
      updatePackageUI(currentPkg);
      fetchPackagePricing();
    }

    root.querySelectorAll('.emoto-tier-card').forEach(function (card) {
      card.addEventListener('click', function () {
        const pkg = card.dataset.package;
        if (pkg) updatePackageUI(pkg);
      });
    });

    root.querySelectorAll('[data-select-tier]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const pkg = btn.dataset.selectTier;
        if (pkg) updatePackageUI(pkg);
      });
    });

    const pricingBackBtn = root.querySelector('[data-pricing-back]');
    if (pricingBackBtn) {
      pricingBackBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setStep(7);
      });
    }

    const paySubmitBtn = root.querySelector('[data-pay-submit-btn]');
    if (paySubmitBtn) {
      paySubmitBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        collectAllCurrentData();

        state.data.package_tier = selectedPackage;
        state.data.pricing_tier = isSelectedPackageFree ? '$0 (Free)' : '$' + selectedPrice;
        saveState();

        const origBtnText = paySubmitBtn.textContent;
        paySubmitBtn.disabled = true;
        paySubmitBtn.textContent = isSelectedPackageFree ? 'Submitting free listing...' : 'Creating checkout...';

        try {
          // 1. Ensure draft is synced to backend and listing_id is generated
          await syncDraftToBackend(8, false);

          if (!state.listing_id) {
            console.error('No listing_id after sync');
            alert('Please check your email and information before proceeding.');
            paySubmitBtn.disabled = false;
            paySubmitBtn.textContent = origBtnText;
            return;
          }

          // 2. Call Checkout API
          const res = await fetch(CHECKOUT_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              listing_id: state.listing_id,
              package_tier: selectedPackage,
            }),
          });

          const resData = await res.json();

          if (!resData.success) {
            alert(resData.error || 'Failed to process checkout. Please try again.');
            paySubmitBtn.disabled = false;
            paySubmitBtn.textContent = origBtnText;
            return;
          }

          // 3. Handle Free vs Paid response
          if (resData.is_free || resData.price === 0) {
            state.data.status = 'submitted';
            saveState();
            setStep(9);
          } else if (resData.checkout_url) {
            paySubmitBtn.textContent = 'Redirecting to checkout...';
            window.location.href = resData.checkout_url;
          } else {
            setStep(9);
          }
        } catch (err) {
          console.error('Checkout error:', err);
          alert('Network error while processing checkout. Please try again.');
          paySubmitBtn.disabled = false;
          paySubmitBtn.textContent = origBtnText;
        }
      });
    }

    /*
     * =========================================================
     * STEP 9: REVIEWING SCREEN
     * =========================================================
     */

    function showReviewingScreen() {
      const data = state.data || {};
      const cat = state.category || 'dirt_bike';
      const catName = CATEGORY_NAMES[cat] || 'Ride';

      const year = data.year || '2023';
      const brand = data.brand === 'Other' ? data.other_brand || 'Custom' : data.brand || 'Sur-Ron';
      const model =
        data.model === 'Other'
          ? data.other_model || 'Custom'
          : data.model || (cat === 'dirt_bike' ? 'Light Bee X' : catName);
      const fullTitle = [year, brand, model].filter(Boolean).join(' ');

      const subtitleEl = root.querySelector('[data-reviewing-subtitle]');
      if (subtitleEl) {
        subtitleEl.textContent =
          'Your ' +
          fullTitle +
          ' is with our team. A real person checks every listing — usually the same day, and always within 24 hours.';
      }

      const pkgInfo = PACKAGE_PRICES[selectedPackage] || PACKAGE_PRICES['3_months'];
      const durationDescEl = root.querySelector('[data-reviewing-duration-desc]');
      if (durationDescEl) {
        durationDescEl.textContent = 'Indexed and searchable, running for your ' + pkgInfo.durationDesc + '.';
      }
    }

    /*
     * =========================================================
     * MODAL POPUP SYSTEM
     * =========================================================
     */

    function showModal(options) {
      const modalOverlay = root.querySelector('[data-emoto-modal]');
      const modalBody = root.querySelector('[data-modal-body]');
      if (!modalOverlay || !modalBody) return;

      let html = '';
      if (options.icon) {
        html += '<div class="emoto-modal-badge ' + (options.iconClass || '') + '">' + options.icon + '</div>';
      }
      if (options.title) {
        html += '<h3 class="emoto-modal-title">' + options.title + '</h3>';
      }
      if (options.subtitle) {
        html += '<p class="emoto-modal-desc">' + options.subtitle + '</p>';
      }
      if (options.htmlContent) {
        html += options.htmlContent;
      }

      html += '<div class="emoto-modal-actions">';
      if (options.secondaryBtnText) {
        html +=
          '<button type="button" class="emoto-modal-btn-secondary" data-modal-secondary>' +
          options.secondaryBtnText +
          '</button>';
      }
      if (options.primaryBtnText) {
        html +=
          '<button type="button" class="emoto-modal-btn-primary" data-modal-primary>' +
          options.primaryBtnText +
          '</button>';
      }
      html += '</div>';

      modalBody.innerHTML = html;
      modalOverlay.hidden = false;
      requestAnimationFrame(function () {
        modalOverlay.classList.add('is-active');
      });

      const primBtn = modalBody.querySelector('[data-modal-primary]');
      if (primBtn) {
        primBtn.addEventListener('click', function () {
          if (typeof options.onPrimary === 'function') {
            const res = options.onPrimary(modalBody);
            if (res !== false) closeModal();
          } else {
            closeModal();
          }
        });
      }

      const secBtn = modalBody.querySelector('[data-modal-secondary]');
      if (secBtn) {
        secBtn.addEventListener('click', function () {
          if (typeof options.onSecondary === 'function') {
            options.onSecondary(modalBody);
          }
          closeModal();
        });
      }
    }

    function closeModal() {
      const modalOverlay = root.querySelector('[data-emoto-modal]');
      if (!modalOverlay) return;
      modalOverlay.classList.remove('is-active');
      setTimeout(function () {
        modalOverlay.hidden = true;
      }, 220);
    }

    root.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    /*
     * =========================================================
     * SAVE & EXIT HANDLER
     * =========================================================
     */

    const saveExitBtn = root.querySelector('[data-save-exit]');
    if (saveExitBtn) {
      saveExitBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        const origText = saveExitBtn.textContent;
        saveExitBtn.disabled = true;
        saveExitBtn.textContent = 'Saving...';

        try {
          await syncDraftToBackend(state.step || 1);
        } catch (err) {
          console.warn('[EMOTO Wizard] Save & Exit sync notice:', err);
        } finally {
          saveExitBtn.disabled = false;
          saveExitBtn.textContent = origText;
        }

        const resumeUrl = new URL(window.location.origin + window.location.pathname);
        resumeUrl.searchParams.set('view', 'listing');
        const activeId = state.listing_code || state.listing_id;
        if (activeId) {
          resumeUrl.searchParams.set('listing_id', activeId);
        }
        resumeUrl.searchParams.set('step', String(state.step || 1));
        const finalUrl = resumeUrl.toString();
        const targetEmail = state.data.user_email || state.data.seller_email || '';
        const vehicleTitle = [state.data.year, state.data.brand, state.data.model].filter(Boolean).join(' ') || 'EMOTO Listing';

        showModal({
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>',
          title: 'Draft Saved',
          subtitle:
            "Your listing progress is safely saved. You can copy your personal resume link or send it to your email to continue anytime.",
          htmlContent: `
            <div class="emoto-magic-modal-body">
              <!-- Option 1: Send to Email -->
              <div class="emoto-magic-card">
                <div class="emoto-magic-card-header">
                  <svg class="emoto-magic-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span class="emoto-magic-card-title">Send Link to Email</span>
                </div>
                <div class="emoto-magic-input-group">
                  <input type="email" class="emoto-magic-input" id="emoto-save-email-input" value="${targetEmail}" placeholder="Enter your email address...">
                  <button type="button" class="emoto-magic-btn" id="emoto-save-email-btn" data-magic-email-send>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                    <span class="emoto-email-btn-text">Send Link</span>
                  </button>
                </div>
                <div class="emoto-magic-feedback" id="emoto-save-email-feedback" style="display:none;"></div>
              </div>

              <div class="emoto-magic-divider">
                <span>OR</span>
              </div>

              <!-- Option 2: Copy Link -->
              <div class="emoto-magic-card">
                <div class="emoto-magic-card-header">
                  <svg class="emoto-magic-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  <span class="emoto-magic-card-title">Copy Direct Link</span>
                </div>
                <div class="emoto-magic-input-group">
                  <input type="text" readonly class="emoto-magic-input emoto-magic-input-readonly" value="${finalUrl}" id="emoto-save-exit-input" onclick="this.select()">
                  <button type="button" class="emoto-magic-btn" id="emoto-save-exit-copy-btn" data-magic-copy>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="emoto-copy-icon">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    <span class="emoto-copy-btn-text">Copy Link</span>
                  </button>
                </div>
                <div class="emoto-magic-feedback emoto-magic-feedback-copy" id="emoto-magic-toast" style="display:none;">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#108043" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Link copied to clipboard!</span>
                </div>
              </div>
            </div>
          `,
          primaryBtnText: 'Keep Editing',
          secondaryBtnText: 'Exit to Home',
          onSecondary: function () {
            window.location.href = '/';
          }
        });

        requestAnimationFrame(() => {
          const copyBtn = root.querySelector('[data-magic-copy]');
          const inputEl = root.querySelector('#emoto-save-exit-input');
          const toastEl = root.querySelector('#emoto-magic-toast');
          const emailSendBtn = root.querySelector('#emoto-save-email-btn');
          const emailInput = root.querySelector('#emoto-save-email-input');
          const feedbackEl = root.querySelector('#emoto-save-email-feedback');

          if (copyBtn) {
            copyBtn.addEventListener('click', async function () {
              if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(finalUrl);
              } else if (inputEl) {
                inputEl.select();
                document.execCommand('copy');
              }
              copyBtn.classList.add('is-copied');
              const btnText = copyBtn.querySelector('.emoto-copy-btn-text');
              if (btnText) {
                btnText.innerHTML = `
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display:inline-block; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Copied!</span>
                `;
              }
              if (toastEl) toastEl.style.display = 'flex';
              setTimeout(() => {
                copyBtn.classList.remove('is-copied');
                if (btnText) btnText.textContent = 'Copy Link';
              }, 3500);
            });
          }

          if (emailSendBtn && emailInput) {
            emailSendBtn.addEventListener('click', async function (e) {
              e.preventDefault();
              const emailVal = emailInput.value.trim().toLowerCase();

              if (!emailVal || !emailVal.includes('@')) {
                if (feedbackEl) {
                  feedbackEl.className = 'emoto-magic-feedback is-error';
                  feedbackEl.innerHTML = `
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <span>Please enter a valid email address.</span>
                  `;
                  feedbackEl.style.display = 'flex';
                }
                emailInput.focus();
                return;
              }

              const btnText = emailSendBtn.querySelector('.emoto-email-btn-text');
              const origText = btnText ? btnText.textContent : 'Send Link';
              emailSendBtn.disabled = true;
              if (btnText) {
                btnText.innerHTML = `
                  <svg class="emoto-btn-spin" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation: emoto-spin 0.8s linear infinite; display: inline-block; vertical-align: middle; margin-right: 4px;"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>
                  Sending...
                `;
              }

              try {
                const resp = await fetch(API_ENDPOINT, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    action_type: 'send_magic_link',
                    email: emailVal,
                    listing_id: state.listing_id || state.listing_code || '',
                    resume_url: finalUrl,
                    step: state.step || 1,
                    seller_name: state.data.seller_name || '',
                    vehicle_title: vehicleTitle,
                  }),
                });

                const resData = await resp.json();
                if (resData.success) {
                  if (btnText) {
                    btnText.innerHTML = `
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display:inline-block; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      <span>Link Sent!</span>
                    `;
                  }
                  emailSendBtn.classList.add('is-sent');
                  if (feedbackEl) {
                    feedbackEl.className = 'emoto-magic-feedback is-success';
                    feedbackEl.innerHTML = `
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#108043" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      <span>Magic link sent to <strong>${emailVal}</strong>! Check your inbox to resume anytime.</span>
                    `;
                    feedbackEl.style.display = 'flex';
                  }
                } else {
                  if (btnText) btnText.textContent = origText;
                  if (feedbackEl) {
                    feedbackEl.className = 'emoto-magic-feedback is-error';
                    feedbackEl.innerHTML = `
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                      <span>${resData.error || 'Failed to dispatch email. Please use Copy Link instead.'}</span>
                    `;
                    feedbackEl.style.display = 'flex';
                  }
                }
              } catch (err) {
                if (btnText) btnText.textContent = origText;
                if (feedbackEl) {
                  feedbackEl.className = 'emoto-magic-feedback is-error';
                  feedbackEl.innerHTML = `
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c52828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <span>Network error sending email. Please copy the link above.</span>
                  `;
                  feedbackEl.style.display = 'flex';
                }
              } finally {
                emailSendBtn.disabled = false;
              }
            });
          }
        });
      });
    }

    /*
     * =========================================================
     * INITIALIZE & RESUME FROM URL
     * =========================================================
     */

    function applyStateToUI() {
      const currentCat = state.category || 'dirt_bike';
      state.category = currentCat;
      root.querySelectorAll('[data-category]').forEach(function (button) {
        button.classList.toggle('selected', button.dataset.category === currentCat);
      });

      if (state.data && (state.data.user_email || state.data.seller_email)) {
        const emailInput = root.querySelector('[data-field="user_email"]');
        if (emailInput) emailInput.value = state.data.user_email || state.data.seller_email || '';
      }

      if (state.data && (state.data.user_phone || state.data.seller_phone)) {
        const phoneInput = root.querySelector('[data-field="user_phone"]');
        if (phoneInput) phoneInput.value = state.data.user_phone || state.data.seller_phone || '';
      }

      if (state.data && state.data.marketing_optin !== undefined) {
        const optinCheckbox = root.querySelector('[data-check-field="marketing_optin"]');
        if (optinCheckbox) optinCheckbox.checked = !!state.data.marketing_optin;
      }
    }

    async function initWizard() {
      loadState();

      const urlParams = new URLSearchParams(window.location.search);
      const paramListingId = urlParams.get('listing_id') || urlParams.get('draft_id') || urlParams.get('id');
      const paramStep = urlParams.get('step') ? parseInt(urlParams.get('step'), 10) : null;

      if (paramListingId) {
        console.log('[EMOTO Wizard] Resuming draft for listing_id:', paramListingId, 'at step:', paramStep || 4);

        // Pre-apply cached local state if it matches for fast rendering
        if ((state.listing_id === paramListingId || state.listing_code === paramListingId) && state.data) {
          applyStateToUI();
          if (paramStep) {
            setStep(paramStep);
          }
        }

        // Fetch fresh draft from backend to guarantee cross-device sync
        try {
          const fetchUrl = `${API_ENDPOINT}?listing_id=${encodeURIComponent(paramListingId)}`;
          const response = await fetch(fetchUrl);
          if (response.ok) {
            const resData = await response.json();
            if (resData.success && resData.listing) {
              const l = resData.listing;
              state.listing_id = l.id;
              state.listing_code = l.listing_code || state.listing_code;
              state.seller_id = l.seller_id || state.seller_id;
              state.category = l.category || state.category || 'dirt_bike';

              // Merge raw_data
              const rawData = l.raw_data || {};
              state.data = Object.assign({}, state.data || {}, rawData);

              // Attach seller contact info if present
              if (resData.seller) {
                state.data.user_email = state.data.user_email || resData.seller.email || '';
                state.data.seller_email = state.data.seller_email || resData.seller.email || '';
                state.data.user_phone = state.data.user_phone || resData.seller.phone || '';
                state.data.seller_phone = state.data.seller_phone || resData.seller.phone || '';
                state.data.seller_name = state.data.seller_name || resData.seller.name || '';
              }

              // Photos restoration
              if (Array.isArray(l.photo_urls) && l.photo_urls.length > 0) {
                if (!state.data.photos || typeof state.data.photos !== 'object') {
                  state.data.photos = {};
                }
                PHOTO_SLOTS.forEach((slot, idx) => {
                  if (!state.data.photos[slot.key] && l.photo_urls[idx]) {
                    state.data.photos[slot.key] = l.photo_urls[idx];
                  }
                });
              }

              saveState();
              applyStateToUI();

              const destStep = paramStep || 4; // Defaults to Images Step 4
              setStep(destStep);
              return;
            }
          }
        } catch (err) {
          console.warn('[EMOTO Wizard] Remote draft fetch error:', err);
        }
      }

      applyStateToUI();
      const initialStep = paramStep || state.step || 1;
      setStep(initialStep);
    }

    initWizard();
  
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmotoWizard);
  } else {
    initEmotoWizard();
  }
})();